"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiChannelsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const ChannelsConverter_1 = require("../ChannelsConverter");
class ApiChannelsClient extends ApiSubClient_1.ApiSubClient {
    async create(request) {
        const contentPartnersLink = this.getLinkOrThrow('channels');
        return this.axios.post((0, expandUrlTemplate_1.default)(contentPartnersLink.href, {}), request);
    }
    async getAll(filterOptions) {
        const channelsLink = this.getLinkOrThrow('channels');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(channelsLink.href, {
            name: filterOptions?.name,
            projection: filterOptions?.projection,
            ingestType: filterOptions?.ingestType,
            size: filterOptions?.size,
            page: filterOptions?.page,
            categories: filterOptions?.categories,
            sort_by: filterOptions?.sort_by,
            education_levels: filterOptions?.education_levels,
        }));
        return ChannelsConverter_1.ChannelsConverter.convertEmbeddedResources(response.data);
    }
    async get(id) {
        const contentPartnerLink = this.getLinkOrThrow('channel');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(contentPartnerLink.href, { id }))
            .then(ChannelsConverter_1.ChannelsConverter.convertResponse);
    }
    async getContentCategories() {
        const contentCategories = this.getLinkOrThrow('contentCategories');
        return this.axios.get(contentCategories.href).then((res) => ({
            categories: res.data._embedded.contentCategories,
        }));
    }
    async update(id, contentPartner) {
        const contentPartnerLink = this.getLinkOrThrow('channel');
        await this.axios.patch((0, expandUrlTemplate_1.default)(contentPartnerLink.href, { id }), contentPartner, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        });
    }
    async getSignedLink(filename) {
        const link = this.getLinkOrThrow('channelsSignedUploadLink').href;
        return this.axios
            .post(link, {
            filename,
        })
            .then((it) => {
            return it.headers.location;
        });
    }
}
exports.ApiChannelsClient = ApiChannelsClient;
//# sourceMappingURL=ApiChannelsClient.js.map